export default {
  resetBoxProps: `
    border: 0;
    margin: 0;
    padding: 0
  `,

  textEllipsis: `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  `,

  noOutlineFocus: `
  :focus {
    outline: none;
  }
  `,
  flexAllCenter: `
    align-items: center;
    display: flex;
    justify-content: center
  `,
  fixListSize: `
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    max-height: 100%;
  `
}
